import React, { useState } from "react";
import ModalForm from "@/components/buttons/ModalForm"; // Ensure correct path
import ModalButton from "@/components/buttons/ModalButton"; // Ensure correct path
import Modal from "@/components/popup/popup"; // Ensure correct path
// import world_map from "@/assets/images/world_map.svg";
const world_map = `${process.env.AWS_API_URL}/asset/images/world_map.svg`;

// Define a mapping of data types to icons
const iconMap = {
  phone: <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"></path></svg>,
  url: <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 496 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"></path></svg>,
  address: <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg>,
  ratingScores: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 text-slate-400"><path d="M12 .587l3.668 7.429 8.184 1.189-5.923 5.769 1.396 8.132-7.325-3.846-7.326 3.846 1.397-8.132-5.923-5.769 8.184-1.189z"></path></svg>,
  email: <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path></svg>,
  // Add more mappings as needed
};

const getIconForCell = (
  header: string,
  cellValue: string | number | null
): React.ReactNode => {
  if (header === "Phone" && cellValue) {
    return iconMap.phone;
  }
  if (header === "Url" && cellValue) {
    return iconMap.url;
  }
  if (header === "Address" && cellValue) {
    return iconMap.address;
  }
  if (header === "Email" && cellValue) {
    return iconMap.email;
  }
  if (header === "Rating" && cellValue) {
    return iconMap.ratingScores;
  }
  // Add more conditions based on your data
  return cellValue !== null ? cellValue : ""; // Default: show the actual value or an empty string if null
};

type DataTableSectionProps = {
  bc_l: { bc_n: string };
  c_l: { cm_n: string };
  s_d: {
    name: string;
    rating: number | null;
    reviews: number | null;
    domain_url: string | null;
    phone: string | null;
    email: string | null;
    address: string;
    city_name: string;
    c_iso: string;
    s_iso: string;
  }[];
  openPurchaseModal: () => void;
  openFreeSampleModal: () => void;
  showPurchaseModal: boolean;
  closePurchaseModal: () => void;
  showFreeSampleModal: boolean;
  closeFreeSampleModal: () => void;
  handlePurchaseSubmit: (
    e: React.FormEvent,
    formData: { email: string; phone: string }
  ) => void;
  handleFreeSampleSubmit: (
    e: React.FormEvent,
    formData: { email: string; phone: string }
  ) => void;
  location_map: string;
};

const DataTableSection: React.FC<DataTableSectionProps> = ({
  bc_l,
  c_l,
  s_d,
  openPurchaseModal,
  openFreeSampleModal,
  showPurchaseModal,
  closePurchaseModal,
  showFreeSampleModal,
  closeFreeSampleModal,
  handlePurchaseSubmit,
  handleFreeSampleSubmit,
  location_map,
}) => {
  // Sample data
  const bcData = { bc_n: bc_l?.bc_n }; // Renamed to avoid conflicts
  const locationData = { cm_n: c_l?.cm_n }; // Renamed to avoid conflicts

  const [isBlurVisible, setIsBlurVisible] = useState(true);

  // Handler to remove the blur layer
  const handleButtonClick = () => {
    setIsBlurVisible(false);
    openFreeSampleModal();
  };

  const [isVisible, setIsVisible] = useState(false);

  const handleToggle = () => {
    setIsVisible(!isVisible);
  };

  return (
    <section className=" px-4 md:px-10 lg:px-20 ">
      <div className="mx-auto max-w-screen-xl">
        <div className="mb-8">
          <h2 className="flex flex-wrap items-center mx-auto text-center tracking-wide justify-center text-[var(--title-color)]  mb-4 mt-8 text-2xl lg:text-4xl font-semibold">
            Free Sample data of <span className="gradient-new-text mx-2">{bc_l?.bc_n}</span> in {c_l?.cm_n}
          </h2>

          <p className="text-[var(--text-color)] mb-4 mt-4 text-center md:text-base">
            Grow your client base with quality B2B leads and other key
            statistics from BizDataset data provider. We source B2B data from
            the web using advanced technology, specialized third-party sources,
            and a dedicated support team. Below is a free sample list of{" "}
            {bc_l?.bc_n} in {c_l?.cm_n} for you to have an overview of what we
            offer.
          </p>
        </div>


        <div className="relative max-h-[600px] overflow-hidden border rounded-lg shadow-sm">
  {/* Blur effect */}
  {isBlurVisible && (
    <div className="absolute inset-0 bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center ">
      <button
        onClick={handleButtonClick}
        className="relative  bg-blue-600 text-white font-semibold rounded-full flex items-center overflow-hidden transition-all duration-300 w-12 h-12 hover:w-[160px]"
      >
        <span className="absolute left-1/2 transform py-2 px-6 -translate-x-1/2 pl-12 opacity-0 hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
          Reveal Data
        </span>
        <div className="flex items-center justify-center pl-[12px] transition-all duration-300 group-hover:translate-x-16">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25px"
            height="25px"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
              fill="#FFFFFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z"
              fill="#FFFFFF"
            />
          </svg>
        </div>
      </button>
    </div>
  )}

            {/* Table */}
            <div className="lg:relative overflow-y-auto max-h-[600px] -z-10">
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-white shadow-sm sticky top-0 z-5">
                <tr>
                  {[
                    "Name",
                    "Rating",
                    "Review",
                    "Url",
                    "Phone",
                    "Email",
                    "Address",
                    "City",
                    "State/Territory",
                    "Country",
                  ].map((header, index) => (
                    <th
                      key={header}
                      className={`px-6 py-3 text-left text-xs font-medium text-[var(--text-color)] bg-slate-200 uppercase tracking-wider ${
                        index === 0 ? "w-1/4" : "" // Fixed width for the first column
                      }`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white bg-opacity-20 divide-y divide-gray-200 text-slate-400">
                {s_d?.map((row, index) => (
                  <tr key={index}>
                    {[
                      row.name,
                      row.rating || 0,
                      row.reviews || 0,
                      row.domain_url || `N/A`,
                      row.phone || `N/A`,
                      row.email || `N/A`,
                      row.address || `N/A`,
                      row.city_name,
                      row.s_iso,
                      row.c_iso,
                    ].map((cell, i) => (
                      <td
                        key={i}
                        className={`px-6 py-4 whitespace-nowrap text-sm ${
                          i === 0
                            ? "w-[150px] min-w-[150px] max-w-[150px] whitespace-nowrap text-ellipsis overflow-hidden"
                            : ""
                        } ${cell === "N/A" ? "text-gray-500 opacity-20" : ""}`}
                      >
                        {i === 1 ? ( // Rating Scores column
                          <div className="flex items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              className="w-3 h-3 text-slate-400" // Star icon style
                            >
                              <path d="M12 .587l3.668 7.429 8.184 1.189-5.923 5.769 1.396 8.132-7.325-3.846-7.326 3.846 1.397-8.132-5.923-5.769 8.184-1.189z" />
                            </svg>
                            <span className="ml-1">{cell}</span>{" "}
                          </div>
                        ) : i === 2 ? ( // Review Count column
                          <span className="rounded-full ring ring-slate-400 px-4 py-1">
                            {getIconForCell(
                              [
                                "Name",
                                "Rating",
                                "Review",
                                "Url",
                                "Phone",
                                "Email",
                                "Address",
                                "City",
                                "State/Territory",
                                "Country",
                              ][i],
                              cell as string
                            )}
                          </span>
                        ) : (
                          getIconForCell(
                            [
                              "Name",
                              "Rating",
                              "Review",
                              "Url",
                              "Phone",
                              "Email",
                              "Address",
                              "City",
                              "State/Territory",
                              "Country",
                            ][i],
                            cell as string
                          )
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
        </div>


        <div className="flex items-center justify-center p-2">
      <div className="w-full max-w-screen-md">
      <button
  onClick={handleToggle}
  className="group flex items-center gap-1 justify-center mb-2 mx-auto text-slate-600 hover:text-[var(--blue-color)] transition-colors duration-300"
>
  <div className="border-b-2 border-dotted hover:border-[var(--blue-color)] border-slate-600 text-[12px]">
    {isVisible ? 'What’s included' : 'What’s included'}
  </div>
  {isVisible ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      className="fill-slate-600 group-hover:fill-[var(--blue-color)] transition-colors duration-300"
    >
      <path d="M19 13H5v-2h14v2z" />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      className="fill-slate-600 group-hover:fill-[var(--blue-color)] transition-colors duration-300"
    >
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </svg>
  )}
</button>



       
<div
  className={`transition-all text-slate-400 text-[14px] duration-300 ease-in-out overflow-hidden ${isVisible ? 'max-h-full whats-new-table' : 'max-h-0'}`}
>
  <div className="h-[350px] md:max-h-[190px] overflow-y-auto">
    <table className="w-full  bg-white">
      <tbody>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Name</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Name of the {bc_l?.bc_n}.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Address</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Full postal address, including street, city, state, and country.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Pincode</td>
          <td className="border-b px-4 py-2 border-l border-gray-200"> The postal code of the {bc_l?.bc_n} location.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Phone Number</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">{bc_l?.bc_n} location phone number.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Email Address</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Associated email address of the {bc_l?.bc_n} location.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Domain URL</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Website URL of the {bc_l?.bc_n}.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Facebook Profile</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} Facebook Profile.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">X (formerly Twitter)</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} X (Twitter).</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Instagram Profile</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} Instagram Profile.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Snapchat Profile</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} Snapchat Profile.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">WhatsApp Account</td>
          <td className="border-b px-4 py-2 border-l border-gray-200"> Link to the {bc_l?.bc_n} WhatsApp number.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">TikTok Account</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} TikTok Account.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">LinkedIn Account</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} LinkedIn Profile.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">YouTube Channel</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Link to the {bc_l?.bc_n} YouTube Channel.</td>
        </tr>
        {/* <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Categories</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Classification of the {bc_l?.bc_n} types.</td>
        </tr> */}
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Image URL</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">Links to images for a visual representation.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Latitude & Longitude</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">{bc_l?.bc_n} geo-coordinates for location-based services and targeted advertising.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">City</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">The city where the {bc_l?.bc_n} is located.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">State</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">The specific state or region within the country where the {bc_l?.bc_n} operates.</td>
        </tr>
        <tr className="hover:bg-gray-100 transition-colors duration-300">
          <td className="border-b px-4 py-2">Country</td>
          <td className="border-b px-4 py-2 border-l border-gray-200">The country, focused on {bc_l?.bc_n} for this dataset.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


      </div>
    </div>

        <div className=" flex md:flex-row flex-col mt-4 md:gap-4 items-center justify-center">
          <ModalButton
            onClick={openPurchaseModal}
            primary={true}
            label="Purchase B2B Leads"
          />
          <ModalButton
            onClick={openFreeSampleModal}
            primary={false}
            label="Download Free Sample Leads"
          />

          <Modal isOpen={showPurchaseModal} onClose={closePurchaseModal}>
            <ModalForm
              pageTitle={
                <>
                  Get list of{" "}
                  <span className="gradient-new-text">{bcData?.bc_n}</span>
                  <span> in {locationData?.cm_n}</span>
                </>
              }
              title="Purchase B2B Leads"
              imageSrc={world_map}
              imageAlt="Image Description"
              buttonText="Purchase Now"
              onSubmit={handlePurchaseSubmit}
            />
          </Modal>

          <Modal isOpen={showFreeSampleModal} onClose={closeFreeSampleModal}>
            <ModalForm
              pageTitle={
                <>
                  Free sample list of{" "}
                  <span className="gradient-new-text">{bcData?.bc_n}</span>
                  <span> in {locationData?.cm_n}</span>
                </>
              }
              title="Free Sample B2B Leads"
              imageSrc={world_map}
              imageAlt="Image Description"
              buttonText="Download Sample"
              onSubmit={handleFreeSampleSubmit}
            />
          </Modal>
        </div>
      </div>
    </section>
  );
};

export default DataTableSection;
